import { render, staticRenderFns } from "./AuthLogo.vue?vue&type=template&id=f0c9bbb4&scoped=true&lang=pug&"
import script from "./AuthLogo.vue?vue&type=script&lang=js&"
export * from "./AuthLogo.vue?vue&type=script&lang=js&"
import style0 from "./AuthLogo.vue?vue&type=style&index=0&id=f0c9bbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c9bbb4",
  null
  
)

export default component.exports